module.exports = __webpack_public_path__ + "static/media/snakeGame.af2a5c35.png";